// extracted by mini-css-extract-plugin
export default {"title":"UsersTab_title__GsF8V","table":"UsersTab_table__bkwAF","btn":"UsersTab_btn__76tXz","pagination":"UsersTab_pagination__8YvB+","active":"UsersTab_active__j1YZk"};